export const cssDefault = {
  "--bg-app": "#F2F4FB",
  "--primary": "#FFCF01",
  "--primary-light": "#FFCF011F",
  "--button-primary": "#FFCF01",
  "--button-primary-font": "#313131",
  "--button-primary-light": "#E5EFFF",
  "--dropdown-primary": "#E7ECF2",
  "--date-picker-primary": "#E7ECF2",
  "--radio-primary": "#FFD800",
  "--radio-primary-light": "#F5DE61",
  "--icon-primary": "#6c8bb0",
  "--modal-primary": "#0064FA",
  "--base-brand-logo-image":
    "url('https://cdn.discordapp.com/attachments/864703587463462932/887970511064268820/Asset_2222x.png')",
  "--base-brand-logo-image-width": "98px",
  "--login-bg-content-left": "linear-gradient(-90deg,#FFCF01,#FFDD4A)",
  "--login-color-content-left": "#000000",
  "--login-btn-bg-content-right": "#FFCF01",
  "--login-btn-font-content-right": "#000000",
  "--login-color-content-right": "#000000",

  "--nav-bar-img-brand":
    "url('https://cdn.discordapp.com/attachments/864703587463462932/887972727670079508/Asset_32x.png')",
  "--nav-bar-img-brand-width": "150px",
  "--nav-bar-bg": "#000000",
  "--nav-bar-bg-brand-name": "#FFCF01",
  "--nav-bar-color-brand-name": "#000000",
  "--nav-bar-icon-color": "#FFF",
  "--nav-bar-text-color": "#FFF",
  "--nav-bar-bg-menu-active-level-one": "#FFCF01",
  "--nav-bar-bg-menu-active-level-two": "#ffe577",
  "--nav-bar-font-menu-active": "#000000",
  "--nav-bar-icon-menu-active": "#000000",

  "--header-bar-bg": "#000000",
  "--header-bar-icon-color": "#FFF",
  "--header-bar-text-color": "#FFF",

  "--data-manage-bi-text-color": "#000000",
  "--data-manage-bi-header-text-color": "#000000",

  "--dynamic-table-column-bg-color": "#FFCF01",
  "--dynamic-table-column-font-color": "#000000",
  "--dynamic-table-sort-none":
    "url('https://cdn.discordapp.com/attachments/864703587463462932/887981956099342416/sort-none.png')",
  "--dynamic-table-sort-asc":
    "url('https://cdn.discordapp.com/attachments/864703587463462932/887983064402231346/Asset_122x.png')",
  "--dynamic-table-sort-desc":
    "url('https://cdn.discordapp.com/attachments/864703587463462932/887983063034888192/Asset_112x.png')",
};
